import React, { useEffect, useState } from "react";
import axios from "axios";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const About = () => {
  const [about_data, setAboutData] = useState({});
  const [homeProducts, setHomeProducts] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchAbouts();
    fetchAboutProducts();
  }, []);
  const fetchAbouts = async () => {
    const response = await axios.post(`${BASE_URL}/api/about/get`);
    setAboutData(response.data.about);
  };
  const fetchAboutProducts = () => {
    axios
      .post(`${BASE_URL}/api/category/get`)
      .then((response) => {
        if (response.data.category.length > 0) {
          setHomeProducts(response.data.category); // Store product data
        }
      })
      .catch((err) => {});
  };

  return (
    <>
      <main className="main-content site-wrapper-reveal">
        {/* Page Title Area */}
        <section
          className="page-content-area"
          data-bg-img="assets/img/photos/bg-page-title.webp"
          style={{
            backgroundImage: `url("../../assets/img/product_img_cover.jpg")`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-content text-center">
                  <h1 className="title text-white">About Our Legacy</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Content Area */}
        <section className="about-area section-space">
          <div className="container">
            <div className="row align-items-center">
              {/* Text Side */}
              <div className="col-lg-7">
                <div className="about-content pe-lg-5">
                  <div className="section-title text-start mb-4">
                    <span className="subtitle-premium">Established 1996</span>
                    <h2 className="title-gold">Sachi Products</h2>
                    <div className="title-separator-left"></div>
                  </div>

                  {/* Using a helper to render the text more beautifully */}
                  <div className="about-text-wrapper">
                    <div
                      style={{
                        whiteSpace: "pre-line",
                        fontSize: "18px",
                        lineHeight: "1.6",
                      }}
                      className="about-content"
                      dangerouslySetInnerHTML={{
                        __html: about_data?.description || "",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Image Side */}
              <div className="col-lg-5">
                <div className="about-thumb-container mt-md-60">
                  <div className="image-border-frame">
                    <img
                      src={
                        about_data.image
                          ? `${BASE_URL}/${about_data.image}`
                          : "assets/img/no-image.jpg"
                      }
                      className="about-img-premium"
                      alt={about_data.name || "Sachi Products Heritage"}
                    />
                  </div>
                  <div className="experience-box">
                    <span className="years">28+</span>
                    <span className="text">Years of Quality</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default About;
